<form
  [formGroup]="latestNewsItemForm"
  (ngSubmit)="saveForm()"
  #ngForm="ngForm">
  <div class="row g-3">
    <div class="form-group col-md-12">
      <label for="title" class="required">Title (Max 100 characters)</label>
      <input
        type="text"
        class="form-control mt-2"
        formControlName="title"
        placeholder=""
        maxlength="100"
        [ngClass]="{ invalid: title.invalid && ngForm.submitted }"
        />
      </div>
      <div class="form-group col-md-6">
        <label for="publishDate" class="required">Publish Date</label>
        <div class="input-group">
          <input
            class="form-control"
            placeholder="yyyy-mm-dd"
            name="publishDate"
            formControlName="publishDate"
            ngbDatepicker
            #publish="ngbDatepicker"
            [ngClass]="{ invalid: publishDate.invalid && ngForm.submitted }"
            />
            <button
              class="btn btn-outline-secondary"
              (click)="publish.toggle()"
              type="button"
              >
              <fa-icon [icon]="faCalendar"></fa-icon>
            </button>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="hrefText">Link text</label>
          <input
            type="text"
            class="form-control"
            formControlName="hrefText"
            placeholder=""
            maxlength="25"
            [ngClass]="{ invalid: hrefText.invalid && ngForm.submitted }"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="hrefLink" class="">Link (URL, include http://)</label>
            <input
              type="text"
              class="form-control mt-2"
              formControlName="hrefLink"
              placeholder=""
              maxlength="250"
              [ngClass]="{ invalid: hrefLink.invalid && ngForm.submitted }"
              />
            </div>
            <div class="col-md-6 formspace">
              <label for="imageUrl" class="form-label required">Upload Image</label>
              <div class="row">
                <div class="col-md-6 mt-1">
                  <input
                    type="text"
                    formControlName="imageFileName"
                    class="form-control"
                    id="imageFileName"
                    placeholder="Select a .jpg or a .png file"
                    [ngClass]="{ invalid: imageFileName.invalid && ngForm.submitted }"
                    />
                  </div>
                  <div class="col-md-6">
                    <div class="file-btn-wrapper">
                      <button type="button" class="btn btn-outline-primary">
                        {{ isEdit ? "Change.. " : "Browse.." }}
                      </button>
                      <input
                        type="file"
                        name="file"
                        (change)="fileChange($event)"
                        accept="image/*"
                        id="logoUpload"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <label>Add New Tags</label>
                  <div>
                    @for (tag of availableTags; track tag; let i = $index) {
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isSelected(tag.id)"
                            (change)="handleCheckboxClick(tag.id)"
                            />
                            {{ tag.tagName }}
                          </label>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="center mt-5">
                    <button
                      type="submit"
                      class="btn btn-primary mb-3"
                      [disabled]="isProcessing"
                      aria-label="save"
                      >
                      Save
                    </button>
                  </div>
                </div>
              </form>
